package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template4.modules.Template4Project
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColorOpacity
import com.anjuros.website.templates.template4.styles.LogoTempalte4Style
import com.anjuros.website.templates.template4.styles.Template4ImageSizeStyle
import com.anjuros.website.templates.template4.styles.Template4ProjectButtonStyle
import com.anjuros.website.templates.template4.styles.Template4ProjectMarginStyle
import com.anjuros.website.templates.template4.util.ResKey
import com.anjuros.website.templates.template4.util.Template4Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text


@Composable
fun Template4ProjectCard(template4Project: Template4Project,animatedMargin: CSSSizeValue<CSSUnit.px>,
                         selectedGallery:(template4Project:Template4Project)->Unit){

    Box(modifier = Template4ProjectMarginStyle.toModifier()){
    Box(modifier = LogoTempalte4Style.toModifier().overflow(Overflow.Hidden)){
        AnjurosImage(
            src = template4Project.image,
            alt="project image",
            modifier = Template4ImageSizeStyle.toModifier().id("imageAbout")
                .objectFit(ObjectFit.Cover)

        )
    }
    Box(modifier = Modifier.align(Alignment.TopCenter).zIndex(2.0)){
        P(
            attrs = Modifier
                .margin(top=animatedMargin)
                .transition(Transition.of("margin", 1000.ms,
                    delay = template4Project.ordinal * 300.ms))
                .fontFamily(Template4Constants.FONT_FAMILY)
                .fontSize(24.px)
                .fontWeight(FontWeight.Normal)
                .color(Colors.White)
                .toAttrs()
        ) {
            Text(LocalText(template4Project.projectName))

        }
    }
    Box(modifier = Modifier.zIndex(2.0f).borderRadius(5.px)
        .margin(bottom = 10.px).backgroundColor(Template4Theme.OpacityPrimary.getColorOpacity()).align(Alignment.BottomCenter)) {
        Link(
            modifier = Modifier.textDecorationLine(TextDecorationLine.None)
                .onClick { selectedGallery(template4Project)  },
            path = Template4Section.Gallery.path
        ) {
            P(
                attrs = Template4ProjectButtonStyle.toModifier()
                    .margin(topBottom = 0.px)
                    .fontFamily(Template4Constants.FONT_FAMILY)
                    .fontSize(18.px)
                    .color(Colors.White)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE4_OPEN_GALERY))

            }
        }
    }
    }
}